import { AppIcon, AppText } from "@toothfairy/shared-ui";
import AppAssets from "@toothfairy/shared-ui/AppAssets";
import AppTextInput from "@toothfairy/shared-ui/AppTextInput";
import AppTheme from "@toothfairy/shared-ui/AppTheme";
import AppToast from "@toothfairy/shared-ui/AppToast";
import {
  copyToClipboard,
  readFromClipboard,
} from "@toothfairy/shared-ui/ClipboardUtils";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { View, useWindowDimensions } from "react-native";
import { isLargeScreen, isMobileScreen } from "../../../MainViewContainer";

const AdminInfoLeaf = ({
  handleClick,
  value,
  caption,
  subcaption,
  title,
  accessibilityLabel,
  width = 475,
  titleStyle,
  wrapperStyle,
  textContainer,
  textStyle,
  marginLeft = 100,
  label = "WorkspaceAPIkey",
  showSimpleText = false,
  subCaptionColor,
  showCopyIconOnSimpleText = true,
  simpleTextWrapperStyle,
  simpleTextStyle,
  titleColor,
  hideShowIcon = false,
  iconSize,
  captionStyle,
  showSecret = false,
  actionIcon,
  onActionIconPress,
  actionIconAccessibilityLabel,
}) => {
  const { width: windowWidth } = useWindowDimensions();
  const AppToasty = AppToast.useToast();
  const [revealed, setRevealed] = useState(false);
  const [revealedWidth, setRevealedWidth] = useState(0);

  const { t } = useTranslation();
  const { currentTheme } = AppTheme.useTheme();
  const handleDefaultClick = async () => {
    try {
      const success = await copyToClipboard(value);
      if (success) {
        AppToasty.show(t("toasts.copied"), {
          type: "success",
        });
      } else {
        AppToasty.show(t("toasts.copyToClipboardFailed"), {
          type: "danger",
        });
      }
    } catch (error) {
      console.error("Copy failed:", error);
      AppToasty.show(t("toasts.copyToClipboardFailed"), {
        type: "danger",
      });
    }
  };
  return (
    <View
      style={[
        {
          flexDirection: "column",
          // alignItems: "center",
        },
        wrapperStyle,
      ]}
    >
      {title && (
        <AppText
          wrapperStyle={[
            { alignSelf: "flex-start", marginTop: 20 },
            titleStyle,
          ]}
          fontWeight="bold"
          color={titleColor || currentTheme?.theme?.font_color}
        >
          {title}
        </AppText>
      )}
      {caption && (
        <AppText
          wrapperStyle={[
            {
              alignSelf: "flex-start",
              marginTop: 10,
              maxWidth: windowWidth - 75,
            },
            captionStyle,
          ]}
          numberOfLines={3}
        >
          {caption}
        </AppText>
      )}
      {showSimpleText ? (
        <View
          style={[
            {
              alignSelf: "flex-start",
              flexDirection: "row",
              alignItems: "center",
              maxWidth: windowWidth - 75,
            },
            simpleTextWrapperStyle,
          ]}
        >
          <AppText
            wrapperStyle={
              showSecret && !revealed && revealedWidth > 0
                ? { width: revealedWidth }
                : undefined
            }
            style={[
              {
                marginRight: 10,
              },
              simpleTextStyle,
            ]}
            numberOfLines={3}
            fontWeight="bold"
            iconSize={iconSize}
          >
            {!isMobileScreen()
              ? showSecret && !revealed
                ? "•".repeat(value?.length || 0)
                : value
              : ""}
          </AppText>
          {showSecret && (
            <AppIcon
              icon={revealed ? AppAssets.icons.eyeSlash : AppAssets.icons.eye}
              size={iconSize || 18}
              color={currentTheme?.theme?.darkGrey}
              isClickable
              onPress={() => setRevealed((r) => !r)}
              style={{ marginLeft: 8 }}
            />
          )}
          {showCopyIconOnSimpleText && (
            <AppIcon
              icon={AppAssets.icons.copy}
              size={iconSize || 18}
              color={currentTheme?.theme?.darkGrey}
              isClickable
              onPress={handleClick || handleDefaultClick}
              style={{ marginLeft: 8 }}
            />
          )}
          {actionIcon && (
            <AppIcon
              icon={actionIcon}
              size={iconSize || 18}
              color={currentTheme?.theme?.darkGrey}
              isClickable
              onPress={onActionIconPress}
              accessibilityLabel={actionIconAccessibilityLabel}
              style={{ marginLeft: 8 }}
            />
          )}
          {showSecret && !revealed && value ? (
            <View
              style={[
                {
                  position: "absolute",
                  left: 0,
                  opacity: 0,
                  zIndex: -1,
                  pointerEvents: "none",
                },
                simpleTextStyle,
              ]}
            >
              <AppText
                numberOfLines={3}
                fontWeight="bold"
                iconSize={iconSize}
                onTextLayout={(e) => {
                  const w = e?.nativeEvent?.lines?.[0]?.width || 0;
                  if (w > 0) setRevealedWidth(w);
                }}
              >
                {value}
              </AppText>
            </View>
          ) : null}
        </View>
      ) : (
        <AppTextInput
          editable={false}
          selectTextOnFocus={false}
          hideShowIcon={hideShowIcon}
          accessibilityLabel={accessibilityLabel}
          onRightIconClick={handleClick || handleDefaultClick}
          value={value || ""}
          label={label}
          rightIcon={AppAssets.icons.copy}
          textContainer={[
            {
              width: Math.min(windowWidth - 75, 500),
              backgroundColor: currentTheme?.theme?.lightGrey,
              marginLeft: isLargeScreen() ? marginLeft : 0,
              marginVertical: 20,
            },
            textContainer,
          ]}
          style={[
            {
              backgroundColor: currentTheme?.theme?.lightGrey,
            },
            textStyle,
          ]}
        />
      )}

      {subcaption && (
        <AppText
          color={subCaptionColor || currentTheme?.theme?.darkGrey}
          numberOfLines={3}
        >
          {subcaption}
        </AppText>
      )}
    </View>
  );
};

export default AdminInfoLeaf;
